import Converter from './Converter';
import { CasinoType, ICasinoProviderConfigurationItem } from 'modules/Casino/types/configuration';
import { projectName } from 'modules/Casino/utils/slots';
import { parseCookies } from '../../utils/parseCookies';
import { QueryTypes } from 'modules/Casino/types/enums/api';

const converter = new Converter();

export const config: ICasinoProviderConfigurationItem<Converter> = {
  type: CasinoType.slots,
  gameListUrl: `evoplay/game_list?project_name=${projectName}&user_geo=Europe`,
  converter,
  sessionUrlData: {
    url: 'evoplay/frame',
    method: QueryTypes.GET,
    converter: converter.convertGameUrl,
    getQuery: params =>
      `?project_name=${projectName}&game_id=${params.gameId}&language=${params.lang}&user_geo=Europe`,
    getHeaders: () => ({ headers: { Authorization: parseCookies() } }),
  },
};
